import React from 'react';
import { useSelector } from 'react-redux';

import { seoStateSelector } from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import SeoCityCountry from '../seo-city-country/seo-city-country';
import SrpSeoDweb from '../SRP/srp-seo-dweb';

const SeoInternationalDweb = props => {
  const seoState = useSelector(seoStateSelector);
  const { queryType } = seoState;

  if (queryType === 'city-country') {
    return <SeoCityCountry />;
  }
  return <SrpSeoDweb />;
};

export default SeoInternationalDweb;
